/**
 * Query keys used by auth, subscription, onboarding, and other flows.
 * When merging filter params into the URL, keep these unless explicitly updated.
 */
export const URL_QUERY_FLOW_KEYS = Object.freeze([
  'cid',
  'i',
  'select',
  'subscription',
  'paymentId',
  'from',
  'invitationId',
]);

/**
 * Shared report filters: dashboard overview, timeline, app usage, screenshots.
 * Same keys in the query string so links can preserve member, range, and timezone.
 */
export const DASHBOARD_OVERVIEW_QUERY = Object.freeze({
  member: 'member',
  start: 'start',
  end: 'end',
  tz: 'tz',
  /** Selected team id (e.g. teams reporting). */
  team: 'team',
  /** Optional report status filter (currently used by teams timeline). */
  status: 'status',
});

/**
 * Add Employee / Employee List: company and team only (shareable deep links).
 * `team` matches {@link DASHBOARD_OVERVIEW_QUERY.team} for consistency.
 */
export const EMPLOYEE_PAGE_QUERY = Object.freeze({
  company: 'company',
  team: 'team',
});
